import React from "react";
import Slider from "react-slick";

const ExperienceSection = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <section className="hm8paddingSection experienceSec">
      <div className="container">
        <div className="row">
          <div className="col-md-7 col-sm-6 col-xs-12 experienceLeft">
            <div className="home8Title">
              <h3>ABOUT ANJALI ENTERPRISES</h3>
              <h1>
                We Have 15+ Years of Experience <br />
                in Industrial Solutions with Successful Projects
              </h1>
              <p>
                Anjali Enterprises has been a trusted name for over 15 years,
                offering top-quality industrial solutions and services. We
                specialize in all types of aluminium glass office partitions,
                toughened glass work, door partitions, ACP cladding panel
                installations, , All Types of doors, Shafty door, ACP cladding panel installations, and many more tailored services for both residential and commercial projects.
 and many more tailored services for both
                residential and commercial projects.
              </p>
              <p>
                With years of experience in providing innovative solutions for
                office partitions, industrial works, renovation, and
                fabrication, we take pride in our work quality, reliability,
                and customer-centric approach. Whether it's installing
                soundproof glass windows, mosquito nets, or handling large-scale
                industrial fabrication projects, we excel in delivering superior
                solutions on time.
              </p>
            </div>

            <div className="iconText">
              <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
              <p>All Types of Aluminium Glass Office Partition</p>
            </div>

            <div className="iconText">
              <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
              <p>All Types of Toughened Glass Work</p>
            </div>

            <div className="iconText">
              <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
              <p>Door Partition Solutions</p>
            </div>

            <div className="iconText">
              <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
              <p>Aluminium Glass Windows for Elegant Interiors</p>
            </div>

            <div className="iconText">
              <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
              <p>Soundproof Glass Windows for Peaceful Environments</p>
            </div>

            <div className="signRow">
              <div className="row">
                <div className="col-md-6 col-sm-6 col-xs-12 signLeftCol">
                  <p className="Coloo">Mr. Dnyanoba Maruti Ghodke</p>
                  <p>
                    <span>CEO & Founder</span>
                  </p>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-12 signCol">
                  {/* <img
                    className="img-responsive"
                    src="images/home8-images/sign.jpg"
                    alt="John Walker"
                  /> */}
                </div>
              </div>
            </div>

            {/* <a href="#" className="home8Button hvr-bounce-to-right">
              Get A Quote
            </a> */}
          </div>

          <div className="col-md-5 col-sm-6 col-xs-12 experienceRight ">
            <Slider {...sliderSettings} className="border border-5">
              <div>
                <img
                  src="images/13.jpeg"
                  className="img-responsive"
                  alt="Industrial Experience 1"
                />
              </div>
              <div>
                <img
                  src="images/11.jpeg"
                  className="img-responsive"
                  alt="Industrial Experience 2"
                />
              </div>
              <div>
                <img
                  src="images/12.jpeg"
                  className="img-responsive"
                  alt="Industrial Experience 3"
                />
              </div>
            </Slider>
            <div className="expImgTitle">
              <div className="row">
                <div className="col-md-3 col-sm-3 col-xs-3">
                  <h1>15</h1>
                </div>
                <div className="col-md-9 col-sm-9 col-xs-9">
                  <h3>Years Experience</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;













// import React from 'react';

// const ExperienceSection = () => {
//   return (
//     <section className="hm8paddingSection experienceSec">
//       <div className="container">
//         <div className="row">
//           <div className="col-md-7 col-sm-6 col-xs-12 experienceLeft">
//             <div className="home8Title">
//               <h3>ABOUT ANJALI ENTERPRISES</h3>
//               <h1>We Have 10+ Years of Experience <br />in Industrial Solutions with Successful Projects</h1>
//               <p>
//                 Anjali Enterprises has been a trusted name for over 10 years, offering top-quality industrial solutions and services. 
//                 We specialize in all types of aluminium glass office partitions, toughened glass work, door partitions, ACP cladding panel installations, 
//                 and many more tailored services for both residential and commercial projects. Our long-standing expertise ensures we bring the best results 
//                 and satisfaction to our clients.
//               </p>
//               <p>
//                 With years of experience in providing innovative solutions for office partitions, industrial works, renovation, and fabrication, 
//                 we take pride in our work quality, reliability, and customer-centric approach. Whether it's installing soundproof glass windows, 
//                 mosquito nets, or handling large-scale industrial fabrication projects, we excel in delivering superior solutions on time.
//               </p>
//             </div>

//             <div className="iconText">
//               <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
//               <p>All Types of Aluminium Glass Office Partition</p>
//             </div>

//             <div className="iconText">
//               <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
//               <p>All Types of Toughened Glass Work</p>
//             </div>

//             <div className="iconText">
//               <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
//               <p>Door Partition Solutions</p>
//             </div>

          
//             <div className="iconText">
//               <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
//               <p>Aluminium Glass Windows for Elegant Interiors</p>
//             </div>

//             <div className="iconText">
//               <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
//               <p>Soundproof Glass Windows for Peaceful Environments</p>
//             </div>

           

//             <div className="signRow">
//               <div className="row">
//                 <div className="col-md-6 col-sm-6 col-xs-12 signLeftCol">
//                   <p>John Walker</p>
//                   <p><span>CEO & Founder</span></p>
//                 </div>
//                 <div className="col-md-6 col-sm-6 col-xs-12 signCol">
//                   <img className="img-responsive" src="images/home8-images/sign.jpg" alt="John Walker" />
//                 </div>
//               </div>
//             </div>

//             <a href="#" className="home8Button hvr-bounce-to-right">Get A Quote</a>
//           </div>

//           <div className="col-md-5 col-sm-6 col-xs-12 experienceRight">
//             <img src="images/home8-images/welcome-img.jpg" className="img-responsive" alt="Industrial Experience" />
//             <div className="expImgTitle">
//               <div className="row">
//                 <div className="col-md-3 col-sm-3 col-xs-3">
//                   <h1>10</h1>
//                 </div>
//                 <div className="col-md-9 col-sm-9 col-xs-9">
//                   <h3>Years Experience</h3>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ExperienceSection;


// import React from 'react';

// const ExperienceSection = () => {
//   return (
//     <section className="hm8paddingSection experienceSec">
//       <div className="container">
//         <div className="row">
//           <div className="col-md-7 col-sm-6 col-xs-12 experienceLeft">
//             <div className="home8Title">
//               <h3>ABOUT INDOFACT INDUSTRY</h3>
//               <h1>We Have 25+ Years Of Experience <br />In Industrial Area with Successful Projects</h1>
//               <p>
//                 Etiam porta sem malesuada magna mollis euismod. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. 
//                 Maecenas faucibus mollis interdum. Donec id elit non mi porta gravida at eget metus. Donec id elit non mi porta gravida at eget metus.
//               </p>
//               <p>
//                 Etiam porta sem malesuada magna mollis euismod. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. 
//                 Maecenas faucibus mollis interdum.
//               </p>
//             </div>

//             <div className="iconText">
//               <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
//               <p>Etiam porta sem malesuada magna mollis euismod.</p>
//             </div>

//             <div className="iconText">
//               <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
//               <p>Etiam porta sem malesuada magna mollis euismod.</p>
//             </div>

//             <div className="iconText">
//               <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
//               <p>Etiam porta sem malesuada magna mollis euismod.</p>
//             </div>

//             <div className="signRow">
//               <div className="row">
//                 <div className="col-md-6 col-sm-6 col-xs-12 signLeftCol">
//                   <p>John Walker</p>
//                   <p><span>CEO & Founder</span></p>
//                 </div>
//                 <div className="col-md-6 col-sm-6 col-xs-12 signCol">
//                   <img className="img-responsive" src="images/home8-images/sign.jpg" alt="John Walker" />
//                 </div>
//               </div>
//             </div>

//             <a href="#" className="home8Button hvr-bounce-to-right">Get A Quote</a>
//           </div>

//           <div className="col-md-5 col-sm-6 col-xs-12 experienceRight">
//             <img src="images/home8-images/welcome-img.jpg" className="img-responsive" alt="Industrial Experience" />
//             <div className="expImgTitle">
//               <div className="row">
//                 <div className="col-md-3 col-sm-3 col-xs-3">
//                   <h1>25</h1>
//                 </div>
//                 <div className="col-md-9 col-sm-9 col-xs-9">
//                   <h3>Years Experience</h3>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ExperienceSection;
